<script setup lang="ts">
/**Basic tabs navigation. Within the slot you should conditionally render
 * the contents using v-if="currentTab === 'tabName'"
 */
import { useRoute, useRouter } from 'vue-router'

const props = defineProps<{
  tabs: Readonly<string[]> | string[]
}>()
const currentTab = defineModel<string>()

const router = useRouter()
const route = useRoute()

function changeTab(tab: string) {
  if (!props.tabs.includes(tab)) {
    return // Tab does not exist in tab options
  }
  currentTab.value = tab
  router.replace({
    query: {
      ...route.query,
      tab: tab,
    },
  })
}

if (route.query.tab) {
  changeTab(route.query.tab as string)
}
</script>
<template>
  <div class="flex h-full w-full flex-col overflow-auto">
    <nav class="border-b border-gray-200 text-center text-sm font-medium text-gray-500">
      <ul class="-mb-px flex flex-nowrap overflow-auto">
        <li class="me-2" v-for="tab in props.tabs" :key="tab">
          <button
            @click="changeTab(tab)"
            :class="`inline-block rounded-t-lg border-b-2 p-4 ${currentTab === tab ? 'border-blue-600 text-blue-600' : 'border-transparent hover:border-gray-300 hover:text-gray-600'}`"
          >
            {{ tab }}
          </button>
        </li>
      </ul>
    </nav>
    <div v-if="$slots" class="flex h-full w-full overflow-auto">
      <slot />
    </div>
  </div>
</template>
